var map = {
	"./admin-icon.png": 1491,
	"./calendar.png": 6676,
	"./edit-banner-img.png": 3827,
	"./edit.png": 1048,
	"./edit_icon.png": 2318,
	"./home-icon.png": 1553,
	"./home.png": 5474,
	"./image.png": 3509,
	"./leave_icon.png": 8835,
	"./light_dark.png": 9145,
	"./messages.png": 2976,
	"./notifications.png": 8558,
	"./personal-details.png": 8905,
	"./preferences.png": 6950,
	"./send.png": 8588,
	"./settings.png": 2097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4725;